import { WebRoutes } from "consts/enpoints/web";
import { Merchant } from "ui/forms/ECommerce";
import { Step, withApplication } from "ui/organizms/ECommerce/Onboarding/common";
import useBankingAndFinance from "./useBankingAndFinance";
import { useOnboardingApplication } from "../../hooks";

const BankingAndFinance = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const bankingAndFinance = useBankingAndFinance();

    return (
        <Step
            title='Banking & Finance'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.Merchant}
        >
            <Merchant.BankingAndFinance.Form
                {...bankingAndFinance}
            />
        </Step>
    );
};

export default withApplication(BankingAndFinance);
